/* Invoice Create, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="invoice-create" class="entity-create">
      <v-card-title>Create Invoice</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-alert
          v-if="serverErrorMessage"
          type="error"
        >
          {{ serverErrorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>
        <v-btn
          color="primary"
          class="me-3"
          @click="Save"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiContentSaveOutline  }}
          </v-icon>
          <span>Save</span>
        </v-btn>
        </v-col>
        <v-col class="text-right">
        <v-btn
          color="secondary"
          class="me-3"
          @click="Back"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiChevronLeft }}
          </v-icon>
          <span>Back</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-form ref="form">
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>

      <tr>
        <td>Reference</td>
        <td><v-text-field
      label="Reference"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Reference').map(x => x.error)"
      v-model="entity.Reference"
      :rules="[validators.required]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Order</td>
        <td><OrderLookup v-model="entity.OrderId" :rules="[validators.requiredInteger]" :error-messages="serverErrors.filter(x => x.field === 'OrderId').map(x => x.error)" /></td>
      </tr>

      <tr>
        <td>Product</td>
        <td><ProductLookup v-model="entity.ProductId" :rules="[]" :error-messages="serverErrors.filter(x => x.field === 'ProductId').map(x => x.error)" /></td>
      </tr>

      <tr>
        <td>Replaced By</td>
        <td><InvoiceLookup v-model="entity.ReplacedId" :rules="[]" :error-messages="serverErrors.filter(x => x.field === 'ReplacedId').map(x => x.error)" /></td>
      </tr>

      <tr>
        <td>Discount Code</td>
        <td><v-text-field
      label="Discount Code"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'DiscountCode').map(x => x.error)"
      v-model="entity.DiscountCode"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Amount</td>
        <td><v-text-field
      label="Amount"
      solo-inverted
			prefix="£"
			type="number"
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Amount').map(x => x.error)"
      v-model="entity.Amount"
      :rules="[validators.requiredNumber]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Discount</td>
        <td><v-text-field
      label="Discount"
      solo-inverted
			prefix="£"
			type="number"
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Discount').map(x => x.error)"
      v-model="entity.Discount"
      :rules="[validators.requiredNumber]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Credit</td>
        <td><v-text-field
      label="Credit"
      solo-inverted
			prefix="£"
			type="number"
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Credit').map(x => x.error)"
      v-model="entity.Credit"
      :rules="[validators.requiredNumber]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Description</td>
        <td><v-text-field
      label="Description"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Description').map(x => x.error)"
      v-model="entity.Description"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>User</td>
        <td><UserLookup v-model="entity.CreatedBy" :rules="[]" :error-messages="serverErrors.filter(x => x.field === 'CreatedBy').map(x => x.error)" /></td>
      </tr>

      <tr>
        <td>Paid Date</td>
        <td><DateField v-model="entity.PaidDate" :rules="[]" :error-messages="serverErrors.filter(x => x.field === 'PaidDate').map(x => x.error)" /></td>
      </tr>

      <tr>
        <td>Paid Amount</td>
        <td><v-text-field
      label="Paid Amount"
      solo-inverted
			prefix="£"
			type="number"
      flat
      :error-messages="serverErrors.filter(x => x.field === 'PaidAmount').map(x => x.error)"
      v-model="entity.PaidAmount"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Payment Info</td>
        <td><v-text-field
      label="Payment Info"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'PaymentInfo').map(x => x.error)"
      v-model="entity.PaymentInfo"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>


        </tbody>
      </v-simple-table>
      </v-form>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'
import * as FrameworkValidators from '@core/utils/validation'
import * as Validators from '@/datahelpers/validation'
import DateField from '@/views/helpers/DateField'
import OrderLookup from '@/views/order/OrderLookup'
import ProductLookup from '@/views/product/ProductLookup'
import InvoiceLookup from '@/views/invoice/InvoiceLookup'
import UserLookup from '@/views/user/UserLookup'

import {
  mdiContentSaveOutline,
  mdiChevronLeft
} from '@mdi/js'
import { ref, watch, computed, expose } from '@vue/composition-api'

export default {
  components: {
    DateField,
    OrderLookup,
		ProductLookup,
		InvoiceLookup,
		UserLookup
  },
  setup() {

    const { route, router  } = useRouter();

    const entity = ref({

    });
    const loading = ref(false);
    const form = ref(null);
    const serverErrors = ref([]);
    const serverErrorMessage = ref(null);

    const Save = function(e) {

      serverErrorMessage.value = null;
      serverErrors.value = [];

      const valid = form.value.validate();

      if (!valid) {
        return;
      }

      loading.value = true;

      store
        .dispatch('app/createInvoice', {
          entity: entity.value
        })
        .then(response => {
          loading.value = false;
          router.push({ name: 'invoice-view', params: { id: response.data.Id } });
        })
        .catch((error) => {
          loading.value = false;
          if (error.error) {
            if (error.message) serverErrorMessage.value = error.message;
            if (error.errors) serverErrors.value = error.errors
          } else {
            console.log(error);
          }
        });
    };

    const Back = () => {
      router.go(-1);
    };

    const validators = {
      ...FrameworkValidators,
      ...Validators
    };

    return {
      Back,
      form,
      Save,
      loading,
      entity,
      Display,
      icons: {
        mdiContentSaveOutline ,
        mdiChevronLeft
      },
      validators,
      serverErrorMessage,
      serverErrors
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-create::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  padding-right: 0;
}
.entity-create::v-deep .v-data-table th:last-child {
  width: 66%;
}
.entity-create::v-deep  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: transparent;
}
.entity-create::v-deep .v-input:not(.error--text) .v-messages {
  min-height: unset;
}
.entity-create::v-deep .v-input .v-messages.error--text {
  margin-bottom: 8px;
}
.entity-create::v-deep .v-input:not(.error--text) .v-text-field__details {
  min-height: unset;
  margin-bottom: 0;
}
.entity-create::v-deep .v-input:not(.error--text) .v-input__slot {
  margin: 0;
  border-radius: 0;
}
.entity-create::v-deep .v-input--selection-controls {
  margin: 10px;
}
</style>

